export class TimeOutClass {
    private static instance: TimeOutClass;
    private idTimeout: ReturnType<typeof setTimeout> | number | null = null;
    private timeouts: Map<string, ReturnType<typeof setTimeout> | number> = new Map();

    private constructor() { }

    public static getInstance(): TimeOutClass {
        if (!TimeOutClass.instance) {
            TimeOutClass.instance = new TimeOutClass();
        }
        return TimeOutClass.instance;
    }

    public getIdTimeout(): ReturnType<typeof setTimeout> | number | null {
        return this.idTimeout;
    }

    public setIdTimeout(id: ReturnType<typeof setTimeout> | number): void {
        if (this.idTimeout !== null) {
            clearTimeout(this.idTimeout);
        }
        this.idTimeout = id;
    }

    /**
    * Définir un timeout avec une clé unique
    * @param key - key unique for the timeout
    * @param id - ID of the timeout
    */
    public setTimeoutWithKey(key: string, id: ReturnType<typeof setTimeout> | number): void {
        if (this.timeouts.has(key)) {
            clearTimeout(this.timeouts.get(key)!);
        }
        this.timeouts.set(key, id);
    }

    public clearIdTimeout(): void {
        if (this.idTimeout !== null) {
            clearTimeout(this.idTimeout);
            this.idTimeout = null;
        }
    }

    /**
    * Annuler un timeout spécifique par sa clé
    * @param key - Clé du timeout à annuler
    */
    public clearTimeoutByKey(key: string): void {
        if (this.timeouts.has(key)) {
            clearTimeout(this.timeouts.get(key)!);
            this.timeouts.delete(key);
        }
    }
}